import client from '../client';

export interface CreateSupportTicketInput {
  name: string;
  phone: string;
  email: string;
  comment: string;
  orderId?: number;
}

export interface SupportTicketTransition {
  Id: number;
  State: number;
  Resolution: string;
  Modified: string;
  ModifiedBy: string;
}

export interface SupportTicket {
  Id: number;
  Name: string;
  Phone: string;
  Email: string;
  Comment: string;
  State: number;
  Modified: string;
  ModifiedBy: string;
  OrderId: number | null;
  Transitions: SupportTicketTransition[];
}

export const supportTicketService = {
  async createSupportTicket(input: CreateSupportTicketInput): Promise<{ id: number }> {
    const response = await client.post('/support-tickets', input);
    return response.data;
  },

  async getTickets(state: number): Promise<SupportTicket[]> {
    const response = await client.get('/support-tickets', { params: { state } });
    return response.data;
  },

  async setState(id: number, state: number, resolution: string): Promise<void> {
    await client.put(`/support-tickets/${id}/state`, { state, resolution });
  },
};
